import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';

export const useAccountElementsStyles = createStyles(({ token }) => ({
  accountSelectDropdown: {
    backgroundColor: ThemeColors.COLOR_WHITE6,
    borderRadius: token.borderRadius,
    border: `1px solid ${token.colorWhite}`,
    boxShadow: `0 2px 20px ${ThemeColors.COLOR_GREY_BLUISH3}`,
    '.ant-select-item': {
      minHeight: 0,
    },
    '.ant-select-item-group, .SearchSingleSelect--Group': {
      position: 'relative',
      padding: `0 0 0 ${ThemeSpaces.SPACE_NORM_15}px`,
      lineHeight: '16px',
      marginTop: token.marginXS,
      '&::before': {
        content: "''",
        display: 'block',
        position: 'absolute',
        top: -token.paddingXS,
        left: 0,
        right: 0,
        transform: 'translateY(-100%)',
        height: token.paddingXS,
        borderTop: `1px solid ${token.colorWhite}`,
        borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
      },
      '&:first-child': {
        marginTop: 0,
        '&::before': {
          display: 'none',
        },
      },
    },
    '.ant-select-item-option, .SearchSingleSelect--Item': {
      lineHeight: '18px',
      transition: 'none',
      '&:hover': {
        backgroundColor: token.colorPrimary,
        color: token.colorWhite,
      },
    },
  },
  accountSelectGroupPartner: {
    color: ThemeColors.COLOR_BLUE3,
    fontStyle: 'italic',
    fontWeight: 900,
    fontSize: token.fontSizeSM,
    textTransform: 'uppercase',
    letterSpacing: '1.8px',
  },
  accountSelectGroupNonPartner: {
    color: token.colorPrimary,
    fontWeight: 900,
    fontSize: token.fontSizeSM,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}));
